class Point {
  constructor(name, direction, expenditureId, transportId, priorityId, sort, start_date, start_time, id = null) {
    this.name = name;
    this.direction = direction;
    this.transport_id = transportId;
    this.expense_id = expenditureId;
    this.priority_id = priorityId;
    this.sort = sort;
    this.start_date = start_date;
    this.start_time = start_time;
    this.id = id;
  }
}

export default Point;
